  function getRandomNumber() {
  var randomValue = Math.floor(Math.random() * 2) + 2;
  return randomValue;
}

function setRandomValueInDiv() {
  var randomDiv = document.getElementById('randomDiv');
  if (randomDiv) {
    randomDiv.innerHTML = 'Only '  + getRandomNumber() + ' left In stock! ';
  }
}

// Call the function to set the random value when the page loads
setRandomValueInDiv();
  console.log(setRandomValueInDiv());